export const LDFeatureFlagDefaultValue = 'No Visibility Change';

//sportingbet brazil
export enum LDRecommendedGamesVariant {
    ControlVariant = 'Var Control ~ Made For You Games Not Visible',
    TestVariantA = 'Var A ~ Made For You Games Visible 3rd Position',
    TestVariantB = 'Var B ~ Made For You Games Visible 4th Position',
}

export const LaunchDarklyShowRGKey = 'ld1-made_for_you_games_placement_sportingbet_brazil';

export const LDRecommendedGamesVariantMap = new Map<string, number>([
    [LDRecommendedGamesVariant.ControlVariant, -1],
    [LDRecommendedGamesVariant.TestVariantA, 2],
    [LDRecommendedGamesVariant.TestVariantB, 3],
]);

// party casino - product segmentation

export enum LDProductSegmentationVariant {
    ControlVariant = 'Var Control ~ No Product Preference Segmentation',
    TestVariantA = 'Var A ~ Live Casino Product Preference Segmentation',
    TestVariantB = 'Var B ~ Diverse Game Types Product Preference Segmentation',
}

export const LDProductSegmentationVariantMap = new Map<LDProductSegmentationVariant, Set<string>>([
    [LDProductSegmentationVariant.ControlVariant, new Set(['LMC_PP_TOPGAMES', 'LMC_POPULAR_EXCLUSIVES'])],
    [LDProductSegmentationVariant.TestVariantA, new Set(['LMC_HOMETOPGAMES1', 'LMC_HOMEEXCLUSIVE1', 'LMC_HOMEBESTOFTHEREST1'])],
    [LDProductSegmentationVariant.TestVariantB, new Set(['LMC_HOMETOPGAMES2', 'LMC_HOMEEXCLUSIVE2', 'LMC_HOMEBESTOFTHEREST2'])],
]);
export const LDProductSegmentationKey = 'ld2-product_preference_containers_party_dotcom';

// Bwin Austria and Germany
export enum BwinLabels {
    Austria = 'AT',
    Germany = 'DE',
}

export enum LDRecommendedVsSinceYouPlayedGamesVariant {
    ControlVariant = 'Var Control ~ Recommended Games Visible 2nd Position',
    TestVariant = 'Var A ~ Since You Played Games Visible 2nd Position',
}

export const LDRecommendedVsSinceYouPlayedGamesKeys: Record<string, string> = {
    [BwinLabels.Germany]: 'ld3-since_you_played_container_bwin.de',
    [BwinLabels.Austria]: 'ld4-since_you_played_container_bwin_dotcom_austria',
};

export const ManageLobbyContainerLDFlags = [LaunchDarklyShowRGKey, LDProductSegmentationKey];
